import { Box, Typography } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const MuiBorderLinearProgress = styled(LinearProgress)(({ bg }) => ({
  width: '100%',
  height: 20,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#e2e2e2',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: bg,
  },
}));

const BorderLinearProgress = ({ color, value }) => {
  const getLabel = (value) => {
    if (value < 50) {
      return '';
    }
    if (value >= 50 && value < 100) {
      return 'In progress';
    }
    return 'Finished';
  };

  const getLabelLeft = (value) => {
    if (value < 50) {
      return 0;
    }
    if (value >= 50 && value < 100) {
      return '20%';
    }
    return '50%';
  };

  return (
    <Box sx={{ position: 'relative', width: '250px' }}>
      <MuiBorderLinearProgress variant="determinate" value={value} bg={color} />
      <Typography
        style={{
          position: 'absolute',
          color: 'white',
          top: '-15%',
          left: getLabelLeft(value),
          transform: 'translateX(-50%)',
        }}
      >
        {getLabel(value)}
      </Typography>
    </Box>
  );
};

export default BorderLinearProgress;
